import * as React from 'react'

import { IItemCard } from '../interface'

import CollectionButton from '../../buttons/collectionButton'
import FavoriteButton from '../../buttons/favoriteButton/favoriteButton'

import * as styles from './lockupListActionPanel.module.css'

const LockupListActionPanel = ({
  item,
  onAddToCollections,
  onAddToFavourites
}: IItemCard) => (
  <div className={styles.root}>
    <CollectionButton
      href={`/bookmarks/widget?item_id=${item.id}`}
      onClick={onAddToCollections}
      isActive={false}
      iconClassName={styles.collectionButton}
    />
    <FavoriteButton
      href={`/favorites?item_id=${item.id}`}
      onClick={onAddToFavourites}
      isActive={item.ui.isInFavourites}
      iconClassName={styles.favoriteButton}
    />
  </div>
)

export default LockupListActionPanel
